import * as yup from 'yup';
import {dateHelper} from '../../../shared/helpers';

export const FormLoadCreateGeneralValidationSchema = () => {
  return yup.object({
    pickupDatetimeStart: yup
      .date()
      .min(dateHelper.now(), "Start can't be before current date and time."),
    addPickupDatetimeRange: yup.boolean().default(false),
    pickupDatetimeEnd: yup.date().when('addPickupDatetimeRange', {
      is: (addPickupDatetimeRange) => {
        return !!addPickupDatetimeRange ? true : false;
      },
      then: yup
        .date()
        .min(
          yup.ref('pickupDatetimeStart'),
          "Deadline can't be before pickup start date",
        ),
    }),

    dropoffDatetimeStart: yup
      .date()
      .min(
        yup.ref('pickupDatetimeStart'),
        "Dropoff can't be before pickup start date",
      ),
    addDropoffDatetimeRange: yup.boolean().default(false),
    dropoffDatetimeEnd: yup.date().when('addDropoffDatetimeRange', {
      is: (addDropoffDatetimeRange) => {
        return !!addDropoffDatetimeRange ? true : false;
      },
      then: yup
        .date()
        .min(
          yup.ref('dropoffDatetimeStart'),
          "Deadline can't be before dropoff start date",
        ),
    }),

    offerExpirationDays: yup
      .number()
      .min(0, 'Days cannot be negative')
      .test(
        'total-time-required',
        'Offer expiration must be greater than 0 (days + hours)',
        function (value) {
          const {offerExpirationHours} = this.parent;
          const days = value || 0;
          const hours = offerExpirationHours || 0;
          const totalHours = days * 24 + hours;
          return totalHours > 0;
        },
      ),
    offerExpirationHours: yup
      .number()
      .min(0, 'Hours cannot be negative')
      .max(23, 'Hours must be between 0 and 23'),
    loadEquipmentSelect: yup
      .array()
      .min(1, 'Please select at least one load equipment'),
  });
};
